import React, { useEffect, useRef, useState } from "react";

const TARGET = 113;

const CounterSection = () => {
  const ref = useRef(null);
  const [count, setCount] = useState(0);
  const started = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !started.current) {
            started.current = true;
            const duration = 1600;
            const startTime = performance.now();
            const tick = (now) => {
              const p = Math.min((now - startTime) / duration, 1);
              const eased = 1 - Math.pow(1 - p, 3);
              setCount(Math.round(eased * TARGET));
              if (p < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          }
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-16 md:py-20" style={{ backgroundColor: "var(--me-navy)" }}>
      <div className="max-w-[900px] mx-auto px-6 text-center">
        <h3 className="text-[19px] md:text-[21px] font-semibold text-white">
          Experts disponibles maintenant
        </h3>
        <div className="mt-3 text-[56px] md:text-[68px] font-extrabold text-white leading-none">
          {count}
        </div>
      </div>
    </section>
  );
};

export default CounterSection;
